import { SettingsGlobal } from "@modules";
import { Breadcrumb } from "@components";

export default function IndexPage() {
  return (
    <div className="container max-content">
      <Breadcrumb
        data={[{ title: "Global Site Settings", href: "/settings/global" }]}
      />
      <div className="flex justify-between items-center flex-wrap mb-5">
        <h1 className="text-3xl">Global Site Settings</h1>
      </div>
      <SettingsGlobal />
    </div>
  );
}
